/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon16Solid = forwardRef('ArchiveBoxOpenDocsIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.35.65A.65.65 0 0 1 5 0h6a.65.65 0 0 1 0 1.3H5a.65.65 0 0 1-.65-.65Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.005 3.85c0-.635.514-1.15 1.15-1.15h7.7c.635 0 1.15.515 1.15 1.15V6h.495a.5.5 0 0 1 .5.5V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6.5a.5.5 0 0 1 .5-.5h.505V3.85ZM4.305 6h7.4V4h-7.4v2ZM5.75 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 5.75 9Z" })));
});
